export const faqItems = [
  {
    id: "faq-1",
    question: "女王调教适合什么样的人参与？",
    answer: "女王调教适合所有对支配与臣服关系感兴趣的成年人，且双方都能够在知情同意的基础上参与。这包括希望探索主导角色的女性、渴望体验臣服感的男性、以及希望了解D/s关系动态的任何人。关键在于：参与者必须是成年人，能够做出理性判断，并且所有互动都建立在自愿和知情同意的基础上。",
  },
  {
    id: "faq-2",
    question: "我是新手，应该如何开始女王调教的旅程？",
    answer: "建议从阅读和学习开始——充分了解女王调教的基本理念、安全规范和沟通技巧。然后，与潜在的伴侣进行坦诚的沟通，讨论双方的期望、边界和底线。可以从低强度、简单的互动开始，逐步深入。记住，匆忙是女王调教中最大的敌人，慢慢来才能走得更远。",
  },
  {
    id: "faq-3",
    question: "女王调教是否安全？如何确保安全？",
    answer: "在遵循正确安全规范的前提下，女王调教是安全的。确保安全的关键措施包括：使用安全词系统、明确硬性边界和软性边界、保持清醒的头脑（避免酒精和药物影响）、掌握基本急救知识、进行充分的事前沟通和事后关怀。请严格遵循SSC（安全、理智、知情同意）和RACK（风险认知知情同意）原则。",
  },
  {
    id: "faq-4",
    question: "支配与臣服关系和日常生活关系有什么区别？",
    answer: "支配与臣服关系是一种有意识的、经过协商的角色扮演和权力交换，通常有明确的时间框架和规则体系。而日常生活中的关系则不涉及这种明确的权力交换。重要的是，女王调教中的支配与臣服并不意味着臣服者在日常生活中也处于从属地位——两者是独立的关系维度。许多臣服者在日常生活中是独立、自信和有主见的人。",
  },
  {
    id: "faq-5",
    question: "女王调教必须包含身体接触吗？",
    answer: "不一定。女王调教的核心是心理层面的支配与臣服，而非身体接触。许多成功的女王调教关系主要通过语言命令、行为指导和情境构建来实现支配效果。即使在网络远程关系中，女王调教也可以通过文字、语音和视频等方式进行。关键在于支配的心理体验，而非特定的身体行为。",
  },
  {
    id: "faq-6",
    question: "如果在调教过程中感到不适或后悔，应该怎么办？",
    answer: "立即使用安全词停止当前互动。安全词是调教关系中最重要的保护机制，使用安全词不是失败，而是负责任的表现。停止后，双方应进行冷静的沟通，讨论不适的原因，调整后续的互动方式。如果出现严重的心理不适，建议暂停调教活动，必要时寻求专业的心理咨询帮助。",
  },
  {
    id: "faq-7",
    question: "如何找到合适的女王调教伴侣？",
    answer: "寻找合适的调教伴侣需要耐心和谨慎。建议通过以下途径：参与相关社群活动扩大社交圈、在安全可靠的社交平台上建立联系、通过朋友介绍认识志同道合的人。在确定关系前，进行充分的沟通和了解，确认双方的期望和边界是否匹配。切勿急于进入调教关系——安全永远比效率更重要。",
  },
  {
    id: "faq-8",
    question: "女王调教会影响心理健康吗？",
    answer: "以正确方式进行的女王调教不仅不会损害心理健康，反而可能带来积极的心理效益——包括增强自信、改善沟通能力、释放压力、提升自我认知等。然而，如果缺乏安全规范、忽视知情同意或存在强迫行为，则可能对参与者造成心理伤害。因此，遵循安全原则和保持健康的关系框架至关重要。",
  },
];